import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Pagination } from '../models/pagination.model';
import { AppConfig } from '../helpers/app.config';
import { Invitation } from '../models/invitation.model';
import { fromHistoryInvitations } from '../reducers/history-invitations.reducer';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  historyInvitations$: Observable<Pagination<Invitation>>;

  constructor(private store: Store, private httpClient: HttpClient) {
    this.historyInvitations$ = this.store.pipe(select(fromHistoryInvitations.selectHistoryInvitationsState));
  }

  getById(candidateId: string, page = '1', officeId: number, clientId: number) {
    return this.httpClient.get<Pagination<Invitation>>(AppConfig.settings.API + '/tests',
      // Agregamos origin para la búsqueda de pruebas.
      { params: { candidateId, page, consultantOfficeId: officeId.toString(), origin: 'ct', clientId: clientId } }
    );
  }

}
